import { ModelRuns } from '../../types';

const modelRunsTotalsComparer = (a: ModelRuns, b: ModelRuns) => {
  const { success: aPassed, errors: aErrors } = a.totals;

  const { success: bPassed, errors: bErrors } = b.totals;

  if (aErrors !== bErrors) return bErrors - aErrors;
  if (aPassed !== bPassed) return bPassed - aPassed;
  return 0;
};

export default modelRunsTotalsComparer;
